import { render, staticRenderFns } from "./secondarySubmit.vue?vue&type=template&id=3c4726a1&scoped=true&"
import script from "./secondarySubmit.vue?vue&type=script&lang=js&"
export * from "./secondarySubmit.vue?vue&type=script&lang=js&"
import style0 from "./secondarySubmit.vue?vue&type=style&index=0&id=3c4726a1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4726a1",
  null
  
)

export default component.exports